import { CheckboxFacet } from "@/components/Facet/CheckboxFacet"
import { LinkFacet } from "@/components/Facet/LinkFacet"
import {
    Close,
    Dialog,
    DialogClose,
    DialogDescription,
    DialogPureContent,
    DialogTitle,
    DialogTrigger,
    FacetProvider,
    FacetSkeletons,
    SliderFacet,
    VisuallyHidden,
    useI18n,
} from "@jog/react-components"
import { NavigationResponse } from "@jog/types"

export const Facets = ({
    data,
    pending,
    onChange,
    expand,
    loaded,
}: {
    data: NavigationResponse
    pending: boolean
    onChange: (value: string) => void
    expand: boolean
    loaded: boolean
}) => {
    if (!loaded || !data) return <FacetSkeletons />

    return (
        <div className="space-y-2">
            {data.facets?.map((facet) => {
                switch (facet.facetsettings.selectiontype) {
                    case "tree":
                    case "link":
                        return (
                            <FacetProvider
                                key={facet.facetsettings.urlkey}
                                facet={facet}
                                className="text-xs lg:text-13"
                                expand={expand}>
                                <LinkFacet />
                            </FacetProvider>
                        )
                    case "checkbox":
                        return (
                            <FacetProvider
                                key={facet.facetsettings.urlkey}
                                facet={facet}
                                className="text-xs lg:text-13"
                                expand={expand}>
                                <CheckboxFacet pending={pending} onChange={onChange} />
                            </FacetProvider>
                        )
                    case "slider":
                        return (
                            <FacetProvider
                                key={facet.facetsettings.urlkey}
                                facet={facet}
                                className="text-xs lg:text-13"
                                expand={expand}>
                                <SliderFacet pageUrl={data.properties.pageurl} />
                            </FacetProvider>
                        )
                }
                return <></>
            })}
        </div>
    )
}

export const MobileFacets = ({
    data,
    pending,
    onChange,
}: {
    data: NavigationResponse
    pending: boolean
    onChange: (value: string) => void
}) => {
    const { $t } = useI18n()

    return (
        <Dialog>
            <DialogTrigger asChild>
                <button className="ease my-0 mx-auto block w-full cursor-pointer select-none border border-gray-dark bg-white py-2 px-7.5 text-center align-middle font-primary text-xs font-medium text-black transition-all lg:hidden">
                    {$t("FILTER")}
                </button>
            </DialogTrigger>
            <DialogPureContent className="left-[50%] top-[50%] h-[80vh] max-h-[600px] w-[80vw] -translate-x-1/2 -translate-y-1/2 px-5 py-2.5">
                <DialogTitle asChild>
                    <VisuallyHidden />
                </DialogTitle>
                <DialogDescription asChild>
                    <VisuallyHidden />
                </DialogDescription>
                <div className="relative flex h-full flex-col pt-12">
                    <div className="absolute right-0 top-3 flex items-center justify-center">
                        <DialogClose aria-label={$t("Close")}>
                            <Close className="h-4 w-4 fill-current" />
                        </DialogClose>
                    </div>
                    <div className="flex-1 overflow-y-auto overflow-x-hidden pb-4">
                        <Facets loaded expand={false} data={data} pending={pending} onChange={onChange} />
                    </div>
                    <div className="my-3 mx-auto flex shrink-0 justify-center">
                        <DialogClose asChild>
                            <button className="border-none bg-black py-2.5 px-2.5 text-xs uppercase text-white no-underline focus:outline-none disabled:opacity-60 lg:py-2.5 lg:px-7.5">
                                {`${$t("Show products")} (${data?.properties?.nrofitems ?? ""})`}
                            </button>
                        </DialogClose>
                    </div>
                </div>
            </DialogPureContent>
        </Dialog>
    )
}
